export default __webpack_public_path__ + "static/media/seen-email-cyan.5d96b2db.svg";